/**
 * Created by dimah on 18/06/17.
 */
import { AbstractDTO } from "./abstract";

export class DTMessagesDTO extends AbstractDTO {
    // Message to show when array is presented
    // but contains no values
    emptyMessage: string;
    // Footer total message
    totalMessage: string;
    // Footer selected message
    selectedMessage: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.emptyMessage = attributes['emptyMessage'] || "No data to display";
        this.totalMessage = attributes['totalMessage'] || "Total";
        this.selectedMessage = attributes['selectedMessage'] || "selected";
    }

}